import TitleDashboard from '@components/general/Titles/TitleDashboard'
import UserContext from '@context/User/UserContext'
import Pricing from '@helpers/helpComponents/Pricing'
import { getCustomerPortal } from '@helpers/httpRequests/httpRequestSuscripciones/httpRequestsSuscripciones'
import { Typography } from '@mui/material'
import React, { useContext } from 'react'
import { Button, Card, Col, Container, Image, Row } from 'react-bootstrap'
import { NotificationManager } from 'react-notifications'

const SuscripcionLicencia = () => {

    const {contextValue, setContextValue} = useContext(UserContext);

    const {usuarioLogeado} = contextValue;

    const {folioContrato, estatusCredencial} = usuarioLogeado;

    const handleCustomerPortal = async () => {
        try {
            const res = await getCustomerPortal({ folioContrato })
            const location = res;


            window.location.replace(location);

        } catch (error) {
            console.log(error)
            NotificationManager.error("Error al recuperar la información de tu suscripción");
            console.log("Error al recuperar la informacion de tu suscripcion");
        }
    }
    
  return (
    <Container fluid className="py-3">
        <Row className="mt-3">
            <Col className="text-center col-12 col-lg-4">
                <Image className="img-fluid" width="650" src={require('@assets/images/Click+ Ofimática.png')} alt="Suscripcion" />
              </Col>
              <Col className='col-12 col-lg-8 mt-3 mb-5 text-center text-lg-start'>
                <h2> Tu suscripcion <span style={{fontWeight: "bold"}}>Click<span className='text-warning'>+</span></span></h2>
                  <Card body className="mb-3" style={{border: 'none'}}>

                      {estatusCredencial !== 0 ? (
                          <p>Tu licencia se encuentra en un plan de suscripción, disfruta de todo el contenido y actualizaciones futuras a nuestros cursos y herramientas de la plataforma.</p>
                      ) : (
                          <p>Tu licencia se encuentra vencida, disfruta de todo el contenido y actualizaciones futuras a nuestros cursos y herramientas de la plataforma reactivandola en un plan mensual o anual.</p>
                      )}
                      <br />
                      {/* 
                                    <Typography variant="body1" gutterBottom>
                                        Renovaciones efectuadas: {folioRenovacion}
                                    </Typography>
                
                                    <br /> */}
                      {estatusCredencial !== 0 ? (
                          <Typography gutterBottom variant="caption">
                                <span className="text-danger">*</span> Dejarás de tener acceso a tu cuenta y perderás todos los beneficios una vez canceles tu suscripción.
                            </Typography>
                      ) : (
                           <Typography gutterBottom variant="caption">
                                <span className="text-danger">*</span> Tendrás acceso a tu cuenta y recuperarás todos los beneficios una vez renueves tu suscripción.
                            </Typography>
                      )}
                      

                      <br />



                      {estatusCredencial !== 0 ? (
                          <Row className='mt-5'>
                              <Col>
                                  <Button onClick={handleCustomerPortal}>Ver información de mi suscripción</Button>
                              </Col>
                          </Row>
                      ) : (
                              <Row className='mt-5'>
                                  <Col>
                                      {/* <form action="https://qacursos.globalclickmexico.com/api/suscripciones/stripe/create-checkout-session" method="POST">
                                    <input type="hidden" name="lookup_key" value="click+_anual" />
                                    <Button class="bg-white p-2 w-full rounded-lg" id="checkout-and-portal-button" type="submit">Elegir plan</Button>
                                </form> */}

                                      <Pricing folioContrato={folioContrato} />

                                  </Col>
                              </Row>
                      )}
                      

                  </Card>

              </Col>
              
        </Row>
        
    </Container>
  )
}

export default SuscripcionLicencia